import { FieldDef } from '@core/models';
import { RelatedToType } from '@shared/enums';
import { CustomFormField } from '../custom-form.types';

export const ADDRESS_PART_FIELDS = new Set([
  'address_string',
  'street_address',
  'city',
  'state',
  'postal_code',
  'latitude',
  'longitude',
]);

export const ADDRESS_COMPOSITE_FIELDS = new Set(['cff_address', 'address_string', 'cff_add_properties']);

export const PROPERTY_ADD_FORM_FIELDS_BLACKLIST = ['project_ids', 'title', ...Array.from(ADDRESS_PART_FIELDS)];

export function buildSelectedFieldsForDrawer(
  selectedFields: CustomFormField[] | null | undefined,
  relatedToType: RelatedToType,
  enabledTypes: readonly RelatedToType[] = [RelatedToType.Company, RelatedToType.Contact, RelatedToType.Property],
): CustomFormField[] {
  if (!enabledTypes.includes(relatedToType)) {
    return selectedFields ?? [];
  }

  const filtered = (selectedFields ?? []).filter((f) => !ADDRESS_PART_FIELDS.has(f.name) && f.name !== 'cff_address');
  const cffAddress: CustomFormField = { name: 'cff_address', isRequired: false, isRemovable: true };

  const templateIdIndex = filtered.findIndex((f) => f.name === 'template_id');
  const nameIndex = filtered.findIndex((f) => f.name === 'name');
  const insertAt = templateIdIndex >= 0 ? templateIdIndex + 1 : nameIndex >= 0 ? nameIndex + 1 : 0;

  return [...filtered.slice(0, insertAt), cffAddress, ...filtered.slice(insertAt)];
}

export function getCustomAddressWithCoordinatesFieldDef(
  relatedToType: RelatedToType,
): Omit<
  FieldDef,
  | 'account_id'
  | 'created_at'
  | 'created_by_id'
  | 'created_by_user_name'
  | 'custom_object_id'
  | 'import'
  | 'locked'
  | 'meta'
  | 'related_to_id'
  | 'displayGroupedType'
  | 'val'
  | 'required_for_import'
  | 'usedForTimeSeries'
  | '_parentFieldName'
  | '_parentFieldLabel'
  | '_parentFieldMeta'
  | 'task_role_id'
  | 'tsTableOptions'
  | 'conditional_styling'
> {
  const isRequired = relatedToType === RelatedToType.Property;
  return {
    name: 'cff_address',
    label: 'Custom Address with Coordinates',
    type: 'text',
    related_to_type: relatedToType,
    isRemovable: !isRequired,
    isRequired,
  };
}
